import { render, staticRenderFns } from "./OBView.vue?vue&type=template&id=4594c042&"
import script from "./OBView.vue?vue&type=script&lang=js&"
export * from "./OBView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports